const stateObj = {
  availableFilters: [],
  selectedStandard: null,
  selectedYear: null,
}

const getters = {
  availableFilters (state) {
    return state.availableFilters
  },
  selectedStandard (state) {
    return state.selectedStandard
  },
  selectedYear (state) {
    return state.selectedYear
  },
}

const mutations = {
  setAvailableFilters (state, filters) {
    state.availableFilters = filters
  },
  setSelectedStandard (state, standard) {
    state.selectedStandard = standard
  },
  setSelectedYear (state, selectedYear) {
    state.selectedYear = selectedYear
  },
}

export default {
  state: stateObj,
  getters,
  mutations,
}
